import { cn } from "@/lib/utils";
import { Tooltip } from "./tooltip";

interface BadgeProps {
  variant?: "default" | "success" | "warning" | "danger" | "info";
  children: React.ReactNode;
  className?: string;
  tooltip?: string;
}

export function Badge({ variant = "default", children, className, tooltip }: BadgeProps) {
  const badge = (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        {
          "bg-gray-100 text-gray-700": variant === "default",
          "bg-emerald-50 text-emerald-700": variant === "success",
          "bg-amber-50 text-amber-700": variant === "warning",
          "bg-red-50 text-red-700": variant === "danger",
          "bg-sky-50 text-sky-700": variant === "info",
        },
        className
      )}
    >
      {children}
    </span>
  );

  if (tooltip) {
    return <Tooltip content={tooltip} side="top">{badge}</Tooltip>;
  }

  return badge;
}
